module.exports = {"apiUrl":"https://api.shadheeskumar.com/api/"};